import { useEffect } from "react"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getForSelect as getLotsForSelect } from '../../../actions/other/lotsActions'

export default function EventFormInsemination({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)
	const { lotsForSelect } = useSelector(state => state.lots)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
		dispatch(getLotsForSelect())
	}, [dispatch])

	const animals = animalsForSelect?.map(a => ({
		value: a._id,
		label: a.identifier,
		lot: a.lot,
		category: a.category
	}))

	const lots = lotsForSelect?.map(l => ({ value: l._id, label: l.identifier }))
	const females = animals?.filter(a => ['vaca', 'novilla'].includes(a.category)) || []
	const sementales = animals?.filter(a => a.category === 'semental') || []

	const selectedLots = state.lots || []
	const selectedAnimalIds = state.animals || []

	// Añadir automáticamente hembras de los lotes seleccionados
	useEffect(() => {
		const relatedFemales = females
			.filter(a => selectedLots.includes(a.lot))
			.map(a => a.value)

		const combined = new Set([...(state.animals || []), ...relatedFemales])

		handleInputChange({
			target: {
				name: 'animals',
				value: Array.from(combined)
			}
		})
	}, [state.lots])

	const selectedFemales = females.filter(f => selectedAnimalIds.includes(f.value))

	const handleAnimalSelect = (selectedOptions) => {
		const selectedIds = selectedOptions.map(opt => opt.value)
		handleInputChange({ target: { name: 'animals', value: selectedIds } })
	}

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_insemination')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.animals')}</Form.Label>
						<Select
							isMulti
							options={females}
							value={selectedFemales}
							onChange={handleAnimalSelect}
							isClearable
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.lots')}</Form.Label>
						<Select
							isMulti
							options={lots}
							value={lots.filter(opt => selectedLots.includes(opt.value))}
							onChange={opts =>
								handleInputChange({ target: { name: 'lots', value: opts ? opts.map(o => o.value) : [] } })
							}
							isClearable
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.date')}</Form.Label>
						<Form.Control
							type="date"
							name="dateEvent"
							value={state.dateEvent || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>

				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.semental')}</Form.Label>
						<Select
							options={sementales}
							value={sementales.find(opt => opt.value === state.semental) || null}
							onChange={opt => handleInputChange({ target: { name: 'semental', value: opt?.value || null } })}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
